import AmioHttpService from './amio-http.service'

class MarketService extends AmioHttpService {
  create(language, name) {
    return this.requestPost('/markets', { language, name })
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  list() {
    return this.requestGet('/markets')
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

export default new MarketService()
